import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const BridgePlaylistPage = lazy(() => import('../components/BridgePlaylistPage'));
const BridgeRouteOutlet = lazy(() => import('../components/BridgeRouteOutlet'));
const BridgeAgendaPage = lazy(() => import('../components/BridgeAgendaPage'));
const BridgeMapPage = lazy(() => import('../components/BridgeMapPage'));

export function bridgeRoutes() {
	return (
		<Route path={FRONTEND_ROUTES.BRIDGE} element={<BridgeRouteOutlet />}>
			<Route path="agenda" element={<BridgeAgendaPage />} />
			<Route path="map/:roomId" element={<BridgeMapPage />} />
			<Route path="playlist/:roomId/:taskType/:taskId" element={<BridgePlaylistPage />} />
		</Route>
	);
}
